module.exports = __webpack_public_path__ + "img/nissanbg.c21496bd.png";